/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/dashboard",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
  },
  {
    header: 'Pages'
  },
  {
    url: '/pages/home',
    name: 'Home',
    slug: '/pages/home',
    icon: 'AlignJustifyIcon'
  },
  {
    url: '/pages/category',
    name: 'Category',
    slug: '/pages/category',
    icon: 'AlignJustifyIcon'
  },
  {
    url: '/pages/post',
    name: 'Post',
    slug: '/pages/post',
    icon: 'AlignJustifyIcon'
  },
  {
    url: '/pages/search',
    name: 'Search',
    slug: '/pages/search',
    icon: 'AlignJustifyIcon'
  },
  {
    url: '/pages/about-us',
    name: 'About Us',
    slug: '/pages/about-us',
    icon: 'AlignJustifyIcon'
  },
  {
    header: "Data",
  },
  {
    url: "/data/clients",
    name: "Clients",
    slug: "clients",
    icon: "UsersIcon",
  },
  {
    url: "/data/staff",
    name: "Staff",
    slug: "staff",
    icon: "CpuIcon",
  },
  {
    url: "/data/categories",
    name: "Categories",
    slug: "categories",
    icon: "GridIcon",
  },
  {
    url: "/data/invoice",
    name: "Invoice",
    slug: "invoice",
    icon: "LayersIcon",
  },
  {
    header: "Service"
  },
  {
    url: "/data/business",
    name: "Business",
    slug: "business",
    icon: "DatabaseIcon",
  },
  {
    url: "/data/banners",
    name: "Banner",
    slug: "banners",
    icon: "ImageIcon",
  },
  {
    url: "/data/top-lists",
    name: "Top List",
    slug: "top-lists",
    icon: "ImageIcon",
  },
]
